export default __webpack_public_path__ + "static/media/love-the-item.7c20b020.svg";